import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {FormInputTextModule} from '../../components/form/form-input-text/form-input-text.module';
import {FormInputPasswordModule} from '../../components/form/form-input-password/form-input-password.module';
import {FormInputDropdownModule} from '../../components/form/form-input-dropdown/form-input-dropdown.module';
import {FormInputCalendarModule} from '../../components/form/form-input-calendar/form-input-calendar.module';
import {FormRadioButtonsModule} from '../../components/form/form-radio-buttons/form-radio-buttons.module';
import {FormInputNumberModule} from '../../components/form/form-input-number/form-input-number.module';
import {FormInputAreaModule} from '../../components/form/form-input-area/form-input-area.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FormInputTextModule,
    FormInputPasswordModule,
    FormInputDropdownModule,
    FormInputCalendarModule,
    FormRadioButtonsModule,
    FormInputNumberModule,
    FormInputAreaModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FormInputTextModule,
    FormInputPasswordModule,
    FormInputDropdownModule,
    FormInputCalendarModule,
    FormRadioButtonsModule,
    FormInputNumberModule,
    FormInputAreaModule
  ]
})
export class FormModule {
}
